import {useEffect} from 'react'
import {useAppDispatch, useAppSelector} from '../hooks'
import {
  selectConfig,
  selectPOIConfig,
  selectMiscConfig,
  selectFilterConfig,
  selectStatesConfig,
  selectDefaultPOIConfig,
  selectDataAggregationConfig,
  selectPersonasConfig,
  selectGeoBoundaryConfig,
  selectDistributionDimensionConfig,
  selectIsConfigLoading,
  selectIsConfigInitialized,
  loadAllConfigs
} from '../slices/configSlice'

// COMPLEX HOOK - For backward compatibility and convenience
// Use when: Migrating from Context, need all config functionality together
export const useConfig = () => {
  const dispatch = useAppDispatch()
  const config = useAppSelector(selectConfig)
  const isInitialized = useAppSelector(selectIsConfigInitialized)

  // Auto-load configs on first use if not already initialized
  useEffect(() => {
    if (!isInitialized) {
      dispatch(loadAllConfigs())
    }
  }, [dispatch, isInitialized])

  return config
}

// SIMPLE SELECTOR HOOKS - For targeted access
// Use when: Only need specific values, performance-critical components
export const usePOIConfig = () => useAppSelector(selectPOIConfig)
export const useMiscConfig = () => useAppSelector(selectMiscConfig)
export const useStatesConfig = () => useAppSelector(selectStatesConfig)
export const useDefaultPOIConfig = () => useAppSelector(selectDefaultPOIConfig)
export const useDataAggregationConfig = () => useAppSelector(selectDataAggregationConfig)
export const usePersonasConfig = () => useAppSelector(selectPersonasConfig)
export const useGeoBoundaryConfig = () => useAppSelector(selectGeoBoundaryConfig)
export const useDistributionDimensionConfig = () => useAppSelector(selectDistributionDimensionConfig)
export const useIsConfigLoading = () => useAppSelector(selectIsConfigLoading)
export const useIsConfigInitialized = () => useAppSelector(selectIsConfigInitialized)
export const useFilterConfig = () => useAppSelector(selectFilterConfig)
